import { inject, Injectable } from '@angular/core';
import { CachedPromise } from '@cache';
import { Config } from '@config';
import { AuthHttp } from '@http';
import { DevExtremeDataSourceAdapter } from '@tools';
import { UrlEnhancerService } from '@url';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class BatchUpgradeService {

    #devExtremeAdaper: DevExtremeDataSourceAdapter = inject(DevExtremeDataSourceAdapter);
    
    constructor(
        private http: AuthHttp,
        private config: Config,
        private urlEnhancer: UrlEnhancerService
    ){}

    public async scheduleBatchUpgrade(data: any) {
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgrades);
        return lastValueFrom(this.http.postJSON(url, data));
    }

    public getBatchUprade(upgradeId: string) {
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgrade, {
            upgradeid : upgradeId
        });
        return lastValueFrom(this.http.getJSON(url));
    }

    public async updateBatchUpgrade(upgradeId: string, data: any) {
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgrade, {
            upgradeid : upgradeId
        });
        return lastValueFrom(this.http.putJSON(url, data));
    }

    public async deleteBatchUpgrade(upgradeId: string) {
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgrade, {
            upgradeid : upgradeId
        });
        return lastValueFrom(this.http.delete(url));
    }


    public async cancelBatchUpgrade(upgradeId: string) {
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.cancelBatchUpgrade, {
            upgradeid : upgradeId
        });
        return lastValueFrom(this.http.putJSON(url, {}));
    }


    // settings.data.isAssigned = (showAssigend) ? 't' : 'f';
    //                 settings.data.tenantId = tenantId;
    //                 settings.data.locale = locale;
    //                 settings.data.isAdministrationPage = true;
    public async getUnsuccessfulPlantsByBatchUpgradeId(batchUpgradeId: string, tenantId: string, locale: string) {
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgradePlantList, {tenantId, batchUpgradeId: batchUpgradeId});
        const options = {
            key: 'SiteId',
            data: {
                locale,
                tenantId,
                batchUpgradeId
            }
        };
        const allBatchUpgradePlants = await this.#devExtremeAdaper.remoteDataSource(url, options);

        const unsuccessfulBatchUpgradePlants = allBatchUpgradePlants.data.filter(current => current.batchUpgradeStatus !== "Succeeded");
        return unsuccessfulBatchUpgradePlants;
    }

    public async getAvailablePlants(tenantId: string, locale: string) {
        const url = this.urlEnhancer.replaceParams(this.config.services.plant.plantList);
        const options = {
            key: 'SiteId',
            data: {
                locale,
                tenantId,
                isAdministrationPage: true,
                showAssigned: 't'
            }
        };
        const data = await this.#devExtremeAdaper.remoteDataSource(url, options);

        return data?.data;
    }

}